export { Menu4 as default } from './Menu4';
